import type { NavLinkTargetOptions } from '@tarslib/types/lib/publishedProject';

export enum NavbarItemTypeEnum {
  Folder = 'folder',
  Menu = 'menu',
  Link = 'link',
}

export type BaseNavbarItem = {
  id: string;
  icon: string | undefined;
  title: string;
  disabled: boolean;
};

export type NavbarFolderItem = BaseNavbarItem & {
  type: NavbarItemTypeEnum.Folder;
  to: string;
  selected: boolean;
};

export type NavbarLinkItem = BaseNavbarItem & {
  type: NavbarItemTypeEnum.Link;
  to: string;
  target: NavLinkTargetOptions;
};

export type NavbarMenuItem = BaseNavbarItem & {
  type: NavbarItemTypeEnum.Menu;
  children: (NavbarFolderItem | NavbarLinkItem | NavbarMenuItem)[];
  selected: boolean;
};

export type NavbarItem = NavbarMenuItem | NavbarFolderItem | NavbarLinkItem;
